import { createReducer, on } from '@ngrx/store';

import { UpsellResponse } from '@shared/flight-itinerary/entities/upsell-flights';
import {
  fetchUpsellOptionsForDesktopErrorAction, fetchUpsellOptionsForDesktopSuccessAction,
  fetchPackageUpsellOptionsErrorAction,
  fetchUpsellOptionsForDesktopAction, fetchFlightsOptionForPackageUpsellAction,
  resetUpsellAction, fetchUpsellOptionsForPackageUpsellForDesktopAction
} from '@upsell/store/actions/upsell.actions';
import { mapUpsellValidOptions } from '@upsell/mappers/upsell.mapper';

export const initialState: UpsellResponse = {} as UpsellResponse;

export const upsellForDesktopReducer = createReducer(
  initialState,
  on(resetUpsellAction, () => initialState),
  on(fetchUpsellOptionsForDesktopAction, () => initialState),
  on(fetchUpsellOptionsForPackageUpsellForDesktopAction, () => initialState),
  on(fetchFlightsOptionForPackageUpsellAction, () => initialState),
  on(fetchUpsellOptionsForDesktopSuccessAction, (state, { upsellOptions }) => mapUpsellValidOptions(upsellOptions)),
  on(fetchPackageUpsellOptionsErrorAction, () => initialState),
  on(fetchUpsellOptionsForDesktopErrorAction, () => initialState)
);
